import { isMobile } from 'mobile-device-detect';
// import ScrollMagic from 'scrollmagic'
const ModalVideo = require('modal-video');

const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;





if ( isMobile ) {
  $('.vhfix').css({ height: window.innerHeight });
}


$( document ).ready(function() {

  // Enable Smooth transitions

  $('.header-inner').removeClass('no-transition');


  // VH fix for mobile

  if ( isMobile ) {
    $('.vhfix').css({ height: window.innerHeight });
  }

  setTimeout(function(){
    if ( isMobile ) {
      $('.vhfix').css({ height: window.innerHeight });
    }
  }, 1000);




});






const targetElement = document.querySelector("#mobile-overlay");





jQuery(function(){
  jQuery("#videoHero").YTPlayer();
});


// Line Truncate

var truncate = function (elem, limit, after) {

  // Make sure an element and number of items to truncate is provided
  if (!elem || !limit) return;

  // Get the inner content of the element
  var content = elem.textContent.trim();

  // Convert the content into an array of words
  // Remove any words above the limit
  content = content.split(' ').slice(0, limit);

  // Convert the array of words back into a string
  // If there's content to add after it, add it
  content = content.join(' ') + (after ? after : '');

  // Inject the content back into the DOM
  elem.textContent = content;

};

var elem = document.querySelector('.truncate');
truncate(elem, 7, '');





new ModalVideo('.js-modal-video');

// new ModalVideo('.js-modal-video', {
//   channel: 'youtube',
//   youtube: {
//     autoplay: 1,
//     cc_load_policy: 1,
//     color: null,
//     controls: 1,
//     disablekb: 0,
//     enablejsapi: 0,
//     end: null,
//     fs: 1,
//     h1: null,
//     iv_load_policy: 1,
//     list: null,
//     listType: null,
//     loop: 0,
//     modestbranding: null,
//     origin: null,
//     playlist: null,
//     playsinline: null,
//     rel: 0,
//     showinfo: 1,
//     start: 0,
//     wmode: 'transparent',
//     theme: 'dark',
//     nocookie: false
//   }

// });






// Force YouTube to Autoplay on Mobile



// $('#video-thumbs a').on('click', function() {

// setTimeout(function(){
//   $(window).trigger('resize');
// }, 1000);

// });

// $('#video-thumbs a').on('click', function() {

// $('.modal-video-movie-wrap iframe').attr('id', 'superplayer');

// var player;


//   var tag = document.createElement('script');
//   tag.src = "//www.youtube.com/iframe_api";
//   var firstScriptTag = document.getElementsByTagName('script')[0];
//   firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);




//     /* probably should tie into the `onReady` event,
//        but for this demo's purpose it's unnecessary.
//        the video will probably be ready by the time
//        you get to the close button. */
//     player = new YT.Player('superplayer');







//   console.log(player);
//   player.playVideo();





// });



// Hamburger

$('.hamburger').on('click', function() {
  $(this).toggleClass('is-active');

  if ($('#mobile-overlay').hasClass('opacity-0')) {
    disableBodyScroll(targetElement);
    $('#mobile-overlay').removeClass('opacity-0')
    $('#mobile-overlay').removeClass('invisible')
    $('#mobile-overlay').addClass('opacity-100')
    $('#mobile-overlay').addClass('visible')
  } else {
    enableBodyScroll(targetElement);
    $('#mobile-overlay').removeClass('opacity-100')
    $('#mobile-overlay').addClass('opacity-0')
    setTimeout(function(){
      $('#mobile-overlay').removeClass('visible')
      $('#mobile-overlay').addClass('invisible')
    }, 300);
  }

});


$('#subscribe-mobile-button').on('click', function() {

  $('.hamburger').removeClass('is-active');

  enableBodyScroll(targetElement);
  $('#mobile-overlay').removeClass('opacity-100')
  $('#mobile-overlay').addClass('opacity-0')
  setTimeout(function(){
    $('#mobile-overlay').removeClass('visible')
    $('#mobile-overlay').addClass('invisible')
  }, 300);

});


// Smooth scroll

$(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 1000);
});



// Hero Fade out on scroll

var controller = new ScrollMagic.Controller();

var tween1 = TweenMax.to("#heroOverlay", 1, {opacity: 1});
var tween2 = TweenMax.to("#body-index header", 1, {backgroundColor: 'rgba(0, 0, 0, 0.98)', paddingTop: '16',paddingBottom: '16'});

// create scenes
var scene1 = new ScrollMagic.Scene({
        triggerElement: "#trigger1",
        duration: '100%',    // the scene should last for a scroll distance of 100px
        offset: 0    // start this scene after scrolling for 50px
    })
    .setTween(tween1)
    .addTo(controller); // assign the scene to the controller

var scene2 = new ScrollMagic.Scene({
        triggerElement: "#trigger1",
        duration: 500,    // the scene should last for a scroll distance of 100px
        offset: 50    // start this scene after scrolling for 50px
    })
    .setTween(tween2)
    .addTo(controller); // assign the scene to the controller


if ($('#instafeed').length) {

var feed = new Instafeed({
        accessToken: InstagramToken,
        limit: 8,
        resolution: 'standard_resolution',
        template: '<a href="{{link}}" target="_blank" class="ItemCard inline-block w-1/2 sm:w-1/3 lg:w-1/4 px-2 md:px-3 my-2 sm:my-3 relative"><div style="background: url({{image}}) no-repeat; background-position:center; width: 100%; height: 100%; padding-bottom: 100%; background-size: cover;" class="insta-pic rounded relative shadow-lg"></div></a>'
    });
    feed.run();

}


// Instagram photos animation

(function() {
  $( document )
    .on( "mousemove", ".ItemCard", function( event ) {

    var halfW = ( this.clientWidth / 2 );
    var halfH = ( this.clientHeight / 2 );

    var coorX = ( halfW - ( event.pageX - this.offsetLeft ) );
    var coorY = ( halfH - ( event.pageY - this.offsetTop ) );

    var degX  = ( ( coorY / halfH ) * 10 ) + 'deg'; // max. degree = 10
    var degY  = ( ( coorX / halfW ) * -10 ) + 'deg'; // max. degree = 10

    $( this ).css( 'transform', function() {

      return 'perspective( 600px ) translate3d( 0, -2px, 0 ) scale(1.1) rotateX('+ degX +') rotateY('+ degY +')';
    } )
      .children( '.ItemCard__summary' )
      .css( 'transform', function() {
      return 'perspective( 600px ) translate3d( 0, 0, 0 ) rotateX('+ degX +') rotateY('+ degY +')';
    } );
  } )
    .on( "mouseout", ".ItemCard", function() {
    $( this ).removeAttr( 'style' )
      .children( '.ItemCard__summary' )
      .removeAttr( 'style' );
  } );
})();



// Header inner page

var num = 20;

$(window).bind('scroll', function() {
  if ($(window).scrollTop() > num) {
    $('.header-inner').addClass('scrolled');
  }
  else {
     $('.header-inner').removeClass('scrolled');

  }
});


// Refresh iframe

if ($('#musicwidget').length) {

$(window).resize(function(){
    $('#musicwidget').attr('src', $('#musicwidget').attr('src'));
});

}


// English Translation toggle

$('#english-translation').on('click', function() {
  $('#english-translation i').toggleClass('fa-toggle-off fa-toggle-on');
  $('.original, .translated').toggleClass('block hidden');
});




// WEBPACK FOOTER //
// ./assets/js/index.js